/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, from, map, of, switchMap } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { DotNetRequestMessageService } from '@mep/web-browser-bridge';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(private router: Router, private messageHandler: DotNetRequestMessageService) {}

  canActivate(next: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {
    const token = next.queryParams['accesstoken'];
    return from<Promise<boolean>>(this.messageHandler.sendRequestAsync('ValidateAccessToken', [token])).pipe(
      switchMap((response) => {
        if (token && this.checkExpProp(token) && this.checkTokenExpiration(token) && response) {
          localStorage.setItem('token', token);
          return of(true);
        }
  
        var tempToken = localStorage.getItem('token');
        if (tempToken && this.checkExpProp(tempToken)) {
          return from<Promise<string>>(this.messageHandler.sendRequestAsync('GetValidAccessToken')).pipe(
            map((response) => {
              localStorage.setItem('token', response);
              return true;
            })
          );
        }
  
        this.router.navigate(['/no-access']);
        return of(false);
      }))
  }

  checkTokenExpiration(token: string) {
    console.dir(token);

    const tokenExpiration = new Date(jwt_decode(token)['exp'] * 1000);
    const currentTimeStamp = new Date();
    return tokenExpiration > currentTimeStamp;
  }

  checkExpProp(token: string) {
    try {
      return jwt_decode(token)['exp'] !== undefined;
    } catch (error) {
      return false;
    }
  }
}
